import AppRoute, { AppRouteProps } from './AppRoute';

export type { AppRouteProps };
export default AppRoute;
